import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import styled from 'styled-components'

export const Line = styled.div<{
  $left: number
  $width: number
  $top: number
  $height: number
}>`
  position: absolute;
  left: ${({ $left }) => $left}px;
  width: ${({ $width }) => $width}px;
  top: ${({ $top }) => $top}px;
  height: ${({ $height }) => $height}px;
  background-color: ${COLORS.primary};
  border: 1px solid ${COLORS.borderColor};
  border-radius: ${RADII.item};
  pointer-events: none;
  opacity: 0.2;
`
